import '@type.engineering/type-engineer.h'
import './polyfills'
import Module from './browser'

/**
 * @license
 * Type-Engineer by Art Deco (c) 2021
 * Commercial License.
 */

/** @type {!_protypes.clone} */
export const clone = Module['clone']
/** @type {!_protypes.subtype} */
export const subtype = Module['subtype']
/** @type {!_protypes.is} */
export const is = Module['is']
/** @type {typeof _protypes.$name} */
export const $name = Module['$name']
/** @type {typeof _protypes.$skip} */
export const $skip = Module['$skip']
/** @type {typeof _protypes.$combine} */
export const $combine = Module['$combine']
/** @type {!_protypes.createProtoLayer} */
export const createProtoLayer = Module['createProtoLayer']
/** @type {typeof _protypes.$combined} */
export const $combined = Module['$combined']
/** @type {typeof _protypes.$originalMethod} */
export const $originalMethod = Module['$originalMethod']

/** @type {typeof engineering.type.SUBTYPE_OPTS} */
export const SUBTYPE_OPTS = Module['SUBTYPE_OPTS']
/** @type {typeof engineering.type.ET} */
export const ET = Module['ET']
/** @type {!engineering.type.time} */
export const time = Module['time']
/** @type {!engineering.type.getTime} */
export const getTime = Module['getTime']
/** @type {!engineering.type.__extend} */
export const __extend = Module['__extend']

/** @type {!engineering.type.getSuper} */
export const getSuper = Module['getSuper']
/** @type {!engineering.type.initAbstract} */
export const initAbstract = Module['initAbstract']
/** @type {!engineering.type.skipAbstract} */
export const skipAbstract = Module['skipAbstract']
/** @type {!engineering.type.assignSupers} */
export const assignSupers = Module['assignSupers']
/** @type {!engineering.type.implementEngineer} */
export const implementEngineer = Module['implementEngineer']
/** @type {!engineering.type.bindPrototype} */
export const bindPrototype = Module['bindPrototype']
/** @type {!engineering.type.construct} */
export const construct = Module['construct']
/** @type {!engineering.type.makeClassSymbol} */
export const makeClassSymbol = Module['makeClassSymbol']
/** @type {!engineering.type.assignPrivateSymbol} */
export const assignPrivateSymbol = Module['assignPrivateSymbol']
/** @type {!engineering.type.assignPrivateSymbols} */
export const assignPrivateSymbols = Module['assignPrivateSymbols']
/** @type {!engineering.type.getSymbols} */
export const getSymbols = Module['getSymbols']
/** @type {!engineering.type.setSymbols} */
export const setSymbols = Module['setSymbols']
/** @type {!engineering.type.iu} */
export const iu = Module['iu']

/** @type {!engineering.type.__checkArgs} */
export const __checkArgs = Module['__checkArgs']

/** @type {typeof engineering.type.Engineer} */
export const Engineer = Module['Engineer']

/** @type {typeof engineering.type.Initialiser} */
export const Initialiser = Module['Initialiser']
